var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDeep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.464 15.464A5 5 0 018 14h8a5 5 0 015 5v2a1 1 0 11-2 0v-2a3 3 0 00-3-3H8a3 3 0 00-3 3v2a1 1 0 11-2 0v-2a5 5 0 011.464-3.536z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a3 3 0 100 6 3 3 0 000-6zM7 7a5 5 0 1110 0A5 5 0 017 7z",
    fill: "#000"
  })));
}
export default SvgUserDeep;